import { API } from '@/modules/api-service/api-service';
import type { Data, Core } from '@strapi/types';

const url = '/project-statuses';

export const getStatuses = async ({ projectId }: { projectId: Data.Entity<'api::release-note.release-note'>['documentId'] }) => {
	const { data: response } = await API().get<
		Core.Helpers.Controllers.GetResponseBody<'api::project-status.project-status', 'getProjectStatuses'>
	>(`${url}/${projectId}`);

	return response;
};

export const createDocumentStatusApi = async ({
	documentId,
	body,
}: {
	documentId: Pick<Data.Entity<'api::project.project'>, 'documentId'>['documentId'];
	body: Core.Helpers.Controllers.GetRequestBody<'api::project-status.project-status', 'create'>;
}) => {
	return await API().post(`${url}/create/${documentId}`, body);
};

export const updateDocumentStatusApi = async ({
	documentId,
	body,
}: {
	documentId: Pick<Data.Entity<'api::project-status.project-status'>, 'documentId'>['documentId'];
	body: Core.Helpers.Controllers.GetRequestBody<'api::project-status.project-status', 'update'>;
}) => {
	return await API().put<
		Core.Helpers.Controllers.GetResponseBody<'api::project-status.project-status', 'update'>,
		Core.Helpers.Controllers.GetRequestBody<'api::project-status.project-status', 'update'>
	>(`${url}/update/${documentId}`, body);
};

export const deleteDocumentStatusApi = async ({
	documentId,
}: {
	documentId: Pick<Data.Entity<'api::project-status.project-status'>, 'documentId'>['documentId'];
}) => {
	return await API().delete(`${url}/delete/${documentId}`);
};
